<ng-container *transloco="let t">
  <div
    class="flex flex-col bg-white md:shadow-md mx-0 md:mx-6 sm:p-6 md:rounded-lg h-full"
    style="overflow: hidden"
  >
    <!-- Header -->
    <div
      class="flex md:flex-row flex-col md:justify-between md:items-center gap-3 pb-6 border-b border-b-mbaza-gray-light"
    >
      <div
        class="flex md:flex-row flex-col md:flex-1 md:items-center gap-2 md:gap-4 min-w-0"
      >
        <span class="font-black uppercase shrink-0"
          >IBIBAZO BY'ABATURAGE ({{ this.totalItems }})</span
        >
        <app-mb-search
          [(searchValue)]="searchValue"
          (searchValueChange)="onSearch($event)"
          [placeholder]="t('searchHere')"
          width="w-full lg:w-2xs"
          class="md:flex-1 lg:flex-none w-full min-w-0"
        />
      </div>
    </div>

    <!-- Table -->
    <div class="relative flex flex-col w-full h-full">
      <div *ngIf="isLoading">
        <app-mb-skeleton></app-mb-skeleton>
      </div>

      <div
        class="w-full overflow-x-auto [scrollbar-width:thin] [scrollbar-color:#8E8E8E]"
      >
        <nz-table
          *ngIf="!isLoading"
          #umuturageTable
          [nzData]="paginatedData"
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
        >
          <thead>
            <tr>
              <th colSpan="2" style="text-align: left">#</th>
              <th>Amazina {{ searchValue }}</th>
              <th>Indangamuntu</th>
              <th>Sex</th>
              <th>Telephone</th>
              <th>District</th>
              <th>Category</th>
              <th>Group</th>
              <th>Imiterere</th>
              <th>Icyakorwa</th>
              <th>Icyakozwe</th>
              <th>Umwanzuro</th>
              <th>Issue Date</th>
              <th>Status</th>
              <th>Sender</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let umuturage of paginatedData; let i = index"
              class="justify-between w-full"
            >
              <!-- # — tablet+ -->
              <td class="hidden md:table-cell w-8 font-bold text-sm">
                {{ umuturage.id }}
              </td>
              <td>
                <button
                  class="p-2 border border-mbaza-gray-dark rounded-sm h-10 cursor-pointer shrink-0"
                  tabindex="0"
                  aria-label="Download Accounts"
                  (click)="showDetailsModal(umuturage)"
                >
                  Details
                </button>
              </td>

              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.amazina }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.indangamuntu }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.sex }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.telephone }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.districtName }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.categoryName }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.groupName }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.imiterere }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.icyakorwa }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.icyakozwe }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.umwanzuro }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.issueDate }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.statusName }}</span>
              </td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">{{ umuturage.senderName }}</span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>

      <nz-pagination
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzTotal]="filteredData.length"
        [nzPageSizeOptions]="[25, 50, 100, 200]"
        [nzShowSizeChanger]="true"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        style="padding-bottom: 50px; text-align: right"
      />
    </div>
  </div>

  <app-mb-modal
    [(isVisible)]="isDetailsModalVisible"
    [title]="t('Case Details')"
    [okText]="t('close')"
    [mobileWidth]="'95%'"
    [desktopWidth]="'80%'"
    (OkActionHandler)="showDetailsModal(null)"
    (CancelActionHandler)="showDetailsModal(null)"
  >
    <div
      class="p-4 overflow-x-auto [scrollbar-width:thin] [scrollbar-color:#8E8E8E]"
    >
      <table *ngIf="selectedUmuturage" class="w-full">
        <tbody>
          <tr>
            <td class="font-bold" style="width: 20%">Amazina</td>
            <td>{{ selectedUmuturage.amazina }}</td>
          </tr>
          <tr>
            <td class="font-bold">Indangamuntu</td>
            <td>{{ selectedUmuturage.indangamuntu }}</td>
          </tr>
          <tr>
            <td class="font-bold">Sex</td>
            <td>{{ selectedUmuturage.sex }}</td>
          </tr>
          <tr>
            <td class="font-bold">Telephone</td>
            <td>{{ selectedUmuturage.telephone }}</td>
          </tr>
          <tr>
            <td class="font-bold">District</td>
            <td>{{ selectedUmuturage.districtName }}</td>
          </tr>
          <tr>
            <td class="font-bold">Category</td>
            <td>{{ selectedUmuturage.categoryName }}</td>
          </tr>
          <tr>
            <td class="font-bold">Group</td>
            <td>{{ selectedUmuturage.groupName }}</td>
          </tr>
          <tr>
            <td class="font-bold">Imiterere</td>
            <td class="py-2">{{ selectedUmuturage.imiterere }}</td>
          </tr>
          <tr>
            <td class="font-bold">Icyakorwa</td>
            <td class="py-2">{{ selectedUmuturage.icyakorwa }}</td>
          </tr>
          <tr>
            <td class="font-bold">Icyakozwe</td>
            <td class="py-2">{{ selectedUmuturage.icyakozwe }}</td>
          </tr>
          <tr>
            <td class="font-bold">Umwanzuro</td>
            <td class="py-2">{{ selectedUmuturage.umwanzuro }}</td>
          </tr>
          <tr>
            <td class="font-bold">Issue Date</td>
            <td>{{ selectedUmuturage.issueDate }}</td>
          </tr>
          <tr>
            <td class="font-bold">Status</td>
            <td>{{ selectedUmuturage.statusName }}</td>
          </tr>
          <tr>
            <td class="font-bold">Sender</td>
            <td>
              {{ selectedUmuturage.senderName }} /
              {{ selectedUmuturage.senderPhone }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div
        class="p-4 w-full overflow-x-auto [scrollbar-width:thin] [scrollbar-color:#8E8E8E]"
      >
        <nz-table *ngIf="selectedUmuturage" #umuturageTable>
          <tbody>
            <tr class="justify-between w-full">
              <td>Amazina</td>
              <td
                class="hidden sm:table-cell max-w-[160px] text-mbaza-gray text-sm"
              >
                <span class="block truncate">
                  {{ selectedUmuturage.amazina }}
                </span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div> -->
    </div>
  </app-mb-modal>
</ng-container>
